import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { MdAssignment } from 'react-icons/lib/md';
import { fetchDocuments, fetchDocumentTags } from '../../actions/project_actions';
import { calcPageCount } from '../../utils';
import PiaTable from './PiaTable';
import PiaUploadZone from './piaUploadZone';
import pdfForm from 'pdfform.js';
import { withAuth } from '../../actions/';
import { fetchProject, fetchFactSheets } from '../../actions/project_actions'
import { fetch_lkp_ProjectType, fetchProjectType } from '../../actions/additional_actions';
import { getProjectType, formatDate } from '../../utils';
import { formatMoney } from '../../utils/budget';

class Pia extends Component {
    constructor (props) {
        super(props);
        this.state = {
            currentType: '',
            currentTag: '',
            currentUser: '',
            currentPage: 0,
            currentPg: 1,
            itemsPerPg: 10
        }

        this.filterByType = this.filterByType.bind(this);
        this.filterByTag = this.filterByTag.bind(this);
        this.filterByUser = this.filterByUser.bind(this);
        this.loadDocuments = this.loadDocuments.bind(this);
        this.loadDocumentTags = this.loadDocumentTags.bind(this);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.loadDocuments();
        this.loadDocumentTags();
        const { projectId } = this.props;
        this.props.fetchProject(projectId);
        this.props.fetch_lkp_ProjectType();
        this.props.fetchProjectType(projectId);
        this.props.fetchFactSheets(projectId);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { count, pageSize } = nextProps;
        const pageCount = calcPageCount(count, pageSize);

        const { currentPage } = this.state;
        
        if (currentPage >= pageCount) {
            this.setState({ currentPage: pageCount - 1 },
                () => {
                    this.loadDocuments();
                    this.loadDocumentTags();
                    });
        }

        if (nextProps.documents.length === 10) {
            this.setState({
                currentPg: 1
            });
        }
    }

    loadDocuments (currentPage=0, afterUpload=false) {
        const { count, pageSize } = this.props;
        const pageCount = calcPageCount(count, pageSize);
        if (currentPage > pageCount - 1) currentPage = pageCount - 1;
        if (afterUpload) currentPage = pageCount -1;
        if (currentPage === -1) currentPage = 0;
        this.props.fetchDocuments(this.props.projectId, currentPage);
    }

    loadDocumentTags () {
        if (this.props.documentTags.length === 0)
            this.props.fetchDocumentTags();
    }

    filterByType (type) {
        if (this.state.currentType === type) type = '';
        this.setState({ currentType: type });
    }

    filterByTag (tag) {
        if (this.state.currentTag === tag) tag = '';
        this.setState({ currentTag: tag });
    }

    filterByUser (userId) {
        if (this.state.currentUser === userId) userId = '';
        this.setState({ currentUser: userId });
    }

    filterDocuments (documents, currentType, currentTag, currentUser) {
        let result = [...documents];
        if (currentType) {
            result = _.filter(result, {documentType: currentType});
        }
        if (currentTag) {
            result = _.filter(result, (doc) => _.some(doc.tags, {value: currentTag}));
        }
        if (currentUser) {
            result = _.filter(result, (doc) => doc.createdUser.id === currentUser);
        }
        return result;
    }

    handleClick(event) {
        this.setState({
            currentPg: Number(event.target.id)
        });
    } 

    on_error(e) {
        console.error(e, e.stack);  // eslint-disable-line no-console
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(e.message));
        document.querySelector('.error').appendChild(div);
    }
    
    empty(node) {
        var last;
        while ((last = node.lastChild)) {
            node.removeChild(last);
        }
    }

    list(buf) {
        var list_form = document.querySelector('.list_form');
        this.empty(list_form);
    
        var cnt = 1;
        var field_specs;
        try {

            var pdftest = pdfForm;

            // eslint-disable-next-line no-undef
            field_specs = pdftest().list_fields(buf);
        } catch (e) {
            this.on_error(e);
            return;
        }
        for (var field_key in field_specs) {
            var row = document.createElement('div');
            row.appendChild(document.createTextNode(field_key));
            list_form.appendChild(row);
            field_specs[field_key].forEach(function(spec, i) {
                if ((spec.type === 'radio') && spec.options) {
                    var fieldset_el = document.createElement('fieldset');
                    spec.options.forEach(function(ostr) {
                        var label = document.createElement('label');
                        var radio = document.createElement('input');
                        radio.setAttribute('type', 'radio');
                        radio.setAttribute('value', ostr);
                        radio.setAttribute('name', field_key + '_' + i);
                        radio.setAttribute('data-idx', i);
                        radio.setAttribute('data-key', field_key);
                        label.appendChild(radio);
                        label.appendChild(document.createTextNode(ostr));
                        fieldset_el.appendChild(label);
                    });
                    row.appendChild(fieldset_el);
                    return;
                }
    
                var input = document.createElement((spec.type === 'select') ? 'select' : 'input');
                input.setAttribute('data-idx', i);
                input.setAttribute('data-key', field_key);
                if (spec.type === 'boolean') {
                    input.setAttribute('type', 'checkbox');
                } else if (spec.type === 'string') {
                    input.setAttribute('value', cnt++);
                } else if ((spec.type === 'select') && spec.options) {
                    spec.options.forEach(function(ostr) {
                        var option_el = document.createElement('option');
                        option_el.appendChild(document.createTextNode(ostr));
                        option_el.setAttribute('value', ostr);
                        input.appendChild(option_el);
                    });
                }
                row.appendChild(input);
            });
        }
    }

    getListProjectTypesSelected(projectTypesSelected) {
        const { projectTypes } = this.props;
        let str = '';
        if (projectTypesSelected  === undefined) 
            return '';

        switch (projectTypesSelected.length) {
                case 0:
                    return '';
                case 1:
                    return getProjectType(projectTypes, projectTypesSelected[0].projectTypeId);
                default:
                    projectTypesSelected.forEach(function(pts) {
                        if (projectTypes === undefined)
                            return '';
                        var ptf = projectTypes.find(function(pt) {
                            return pts.projectTypeId === pt.id;
                        });
                        if (ptf !== undefined)
                            if (str === '')
                                str = ptf.projectType;
                            else
              str = str.concat(', ', ptf.projectType);
                    });
                    return str;
        }
    }

    sumColumnForRows = (list) => (column) => {
        const sum = list.reduce((sum, item) => sum + item[column], 0);
        return formatMoney(sum);
    }
    
    retrieveAndFillPdf() {
        const { projectId, projectName, projectStatus, projectSponsor, projectPriority, 
            projectTypesSelected, schedule, budgets, factSheet, projectScope } = this.props;

        let url = 'projects/piapdf';
        let method = 'get';
        let responseType = 'arraybuffer';

        withAuth(
            { method, url, responseType },
            (response) => {
                //this.list(response.data);
                var budgetsToSum;
                if (budgets && budgets[0]) {
                    budgetsToSum = budgets[0].budget
                }
                const sumColumn = this.sumColumnForRows(budgetsToSum);
                var fields = {
                    'Project ID Number': [projectId],
                    'Project Name': [projectName],
                    'Project Status': [projectStatus],
                    'Agency Sponsor': [projectSponsor],
                    'Project Priority': [projectPriority],
                    'Project Type': [this.getListProjectTypesSelected(projectTypesSelected)],
                    'Project Schedule': ['Design Completion: ' 
                        + formatDate(schedule.designCompletion.actual === null ? schedule.designCompletion.projected : schedule.designCompletion.actual) 
                        + ', Construction Start: ' 
                        + formatDate(schedule.constructionStart.actual === null ? schedule.constructionStart.projected : schedule.constructionStart.actual)],
                    'Project Cost': [sumColumn('plannedAmount')],
                    'Project CB Number': [factSheet.communityBoard === null ? '' : factSheet.communityBoard],
                    'Project CD Number': [factSheet.cityCouncilDistrict === null ? '' : factSheet.cityCouncilDistrict],
                    'Project Scope/Intent': [projectScope]
                };

                var pdftest = pdfForm;
                var out_buf = pdftest().transform(response.data, fields);

                var blob = new Blob([out_buf], {type: 'application/pdf'});
                var downloadUrl = window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = downloadUrl;
                link.download='PAF_' + projectId + '.pdf';
                link.click();
            },
            this.errorHandler
        )
    }

    render () {
        const { projectId, documentTags, permissions, documents, pageSize, count } = this.props;
        const { currentType, currentTag, currentUser, currentPage } = this.state;
        var filtered = this.filterDocuments(documents, currentType, currentTag, currentUser);
        const { roleModules } = permissions.editPrivileges;

        const canEdit = roleModules !== null && roleModules.includes('Documents') 
    ? true : false;
  
        const { currentPg, itemsPerPg } = this.state;

    // Logic for displaying items
        const indexOfLastItem = currentPg * itemsPerPg;
        const indexOfFirstItem = indexOfLastItem - itemsPerPg;
        filtered = filtered.filter(d => d.documentType === 'projectAssessment');
        const currentDocs = filtered.slice(indexOfFirstItem, indexOfLastItem);

    // Logic for displaying page numbers
        const pageNumbers = [];
      
        for (let i = 1; i <= Math.ceil(this.props.documents.filter(d => d.documentType === 'projectAssessment').length / itemsPerPg); i++) {
            pageNumbers.push(i);
        }

        var canAdd = true

        try {
            return (
        <div id="pia" className="row-wide project-documents">
          <div className="col s12">
            <h4 className="bar-bottom">
              <span><MdAssignment size={20} /></span> Project Assessment Forms (PAF)
            </h4>
          </div>
          { canAdd
          ? <div className="section-buttons">
            <button className="btn-save" onClick={() => this.retrieveAndFillPdf()}>
                New PAF
              </button>
            </div>
         : null }

          {documents.length === 0 && !canEdit &&
            <div className="col s12">
              <div>This project has no project impact assessments yet.</div>
            </div>
          }
      
          <div className={'col s12'}>

          {canAdd ?
              <div className="margin-top-1">
                <PiaUploadZone
                  projectId={projectId}
                  documentTags={documentTags}
                  onFileUploaded={() => this.loadDocuments(currentPage, true)}
                  onDrop={this.loadDocumentTags}
                  currentPage={currentPage}
                />
              </div>
              : null
            } 

            <div className="error"></div>

            <form className="list_form"></form>

            {currentDocs.length ? 
              <PiaTable
                documents={currentDocs}
                count={count}
                pageSize={pageSize}
                permissions={permissions}
                documentTags={documentTags}
                onDocSaved={() => this.loadDocuments(0, true)}
                onDocDeleted={this.loadDocuments}
                onPage={this.loadDocuments}
                currentPage={currentPage}
              /> 
              : null
            }

        {pageNumbers.length > 1 &&
              <div className="col s12">
                <div className="pagination-blue-book">
                  <ul id="page-numbers">
                    {pageNumbers.map(number => {
                        return <li
                        key={number}
                        id={number}
                        onClick={this.handleClick}
                        className={currentPg === number ? 'active' : ''}
                      >
                        {number}
                      </li>
                    })}
                  </ul>
                </div>
              </div>}
          </div>
        </div>
            );
        } catch (e) {
            console.log('render error: ', e);
        }
    }
}

Pia.propTypes = {
    projectId: PropTypes.string.isRequired,
    pageSize: PropTypes.number,
    permissions: PropTypes.object.isRequired,
    documents: PropTypes.array.isRequired,
    count: PropTypes.number,
    documentTags: PropTypes.array.isRequired,
    fetchDocuments: PropTypes.func.isRequired,
    fetchDocumentTags: PropTypes.func.isRequired,
    fetchProject: PropTypes.func.isRequired,
    projectName: PropTypes.string,
    projectStatus: PropTypes.string,
    projectSponsor: PropTypes.string,
    projectPriority: PropTypes.string,
    fetch_lkp_ProjectType: PropTypes.func.isRequired,
    fetchProjectType: PropTypes.func.isRequired,
    projectTypes:  PropTypes.array.isRequired,
    projectTypesSelected: PropTypes.array,
    schedule: PropTypes.object.isRequired,
    budgets: PropTypes.array.isRequired,
    fetchFactSheets: PropTypes.func.isRequired,
    factSheet: PropTypes.object.isRequired
};

function mapStateToProps (state, ownProps) {
    return {
        projectId: ownProps.projectId,
        documents: state.projectsStore.documents,
        count: state.projectsStore.count,
        pageSize: state.projectsStore.pageSize,
        documentTags: state.projectsStore.documentTags,
        projectScope: state.projectsStore.info.scope,
        projectName: state.projectsStore.info.projectDescription,
        projectStatus: state.projectsStore.info.benchmarkStatus,
        projectSponsor: state.projectsStore.info.sponsor,
        projectPriority: state.projectsStore.info.priority,
        projectTypes: state.additionalProjectsStore.projectTypes,
        projectTypesSelected: state.additionalProjectsStore.projectTypesSelected,
        schedule: state.projectsStore.schedule,
        budgets: state.projectsStore.budgets,
        factSheet: state.projectsStore.factSheet
    };
}

export default connect(mapStateToProps, {
    fetchDocuments,
    fetchDocumentTags,
    fetchProject,
    fetch_lkp_ProjectType,
    fetchProjectType,
    fetchFactSheets
})(Pia);